/* 契約辞退受付完了 */
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import Block from '../../molecules/Block';
import Heading from '../../molecules/Heading';
import TransitionButton from '../../molecules/TransitionButton';
import { handleBrowserBack } from '../../BrowserBack';

const DecliningContract: React.FC = () => {
  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
  }, []);

  // マイページへ戻るボタン押下
  const transitionMypage = () => {
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/mypage/list`);
  };
  return (
    <>
      <Heading label="契約手続き" size="l" />
      <Block
        label="契約辞退受付完了"
        content={
          <>
            <div className="p-lead my-3">
              契約辞退の受付を完了しました。
              <br />
              お申込人および連帯債務者等の方全員に契約辞退通知メールをお送りしました。
              <br />
              ウィンドウまたはタブを閉じて下さい。
            </div>

            <TransitionButton
              label="マイページへ戻る"
              btn_class="two_lines"
              handleClick={transitionMypage}
            />
          </>
        }
      />
    </>
  );
};

if (document.getElementById('declining-contract')) {
  ReactDOM.render(<DecliningContract />, document.getElementById('declining-contract'));
}
